import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postSyncOrganizationSecurityAlerts } from '@api';

export const coreSyncSecurityAlertsPostSlice = createPostAsyncSlice({
	name: 'CoreSyncSecurityAlerts',
	receive: false,
	request: true,
	requestHandler: postSyncOrganizationSecurityAlerts
});
